/**
 * Fondos de pagina de las pantallas de onboarding / suscripcion / portal.
 *
 * Antes cada pagina traia su gradiente hardcodeado en claro, asi que en dark
 * mode quedaban tarjetas oscuras de AntD flotando sobre una pagina clara. Se
 * derivan con color-mix / variables (patron de facturacion.css) para que el
 * tinte se conserve en ambos temas sin duplicar bloques [data-theme="dark"].
 *
 * Son DOS superficies, no una: las pantallas de plan van con el teal de marca,
 * y las de tramite (redireccion, autofactura) iban en gris neutro. Se mantienen
 * separadas a proposito -- unificarlas volveria teal el portal de autofactura,
 * que es el que ve el cliente final del restaurante.
 */

/**
 * Teal de marca. Origen: `linear-gradient(135deg, #f0fdfc 0%, #e0f7f6 100%)`.
 * Lo usan SelectPlan, SubscriptionSuccess y SubscriptionCancel.
 */
export const ONBOARDING_PAGE_BACKGROUND =
  'linear-gradient(135deg, color-mix(in srgb, var(--color-primary) 5%, var(--bg-primary)) 0%, color-mix(in srgb, var(--color-primary) 12%, var(--bg-primary)) 100%)';

/**
 * Gris neutro, sin tinte de marca. Origen: `#f5f7fa -> #e4e8ec`
 * (RedirectingToStripe) y `#f5f7fa -> #c3cfe2` (AutofacturaPortal).
 */
export const ONBOARDING_PAGE_BACKGROUND_NEUTRAL =
  'linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%)';
